<div class="bodycontent">
  <!-- Search Header -->
  <div class="subheader with-padding flgrow">
    <div class="row">
      <div
        class="col-lg-2 col-md-6 col-sm-8"
        *ngIf="dealers && dealers?.length > 0"
      >
        <div class="relative flmid">
          <div class="flgrow">
            <ng-select
              class="w-100"
              placeholder="{{ 'lblSelectDealer' | translate }}"
              [(ngModel)]="dealerId"
              name="dealerId"
              (change)="onDealerChanged($event)"
            >
              <ng-option
                *ngFor="let dealer of dealers"
                [value]="dealer.dealerId"
              >
                {{ dealer.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <p *ngIf="isRequired" class="help-block text-danger" translate>
          lblRequiredDealer
        </p>
      </div>
      <!-- Multiselect Dealer Dropdown -->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="input-group">
          <ng-multiselect-dropdown
            style="width: 100%"
            [settings]="dropdownSettings"
            [data]="mechanicList"
            placeholder="{{ 'lblSelectMechanic' | translate }}"
            [(ngModel)]="selectedMechanics"
          >
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-8">
        <div class="relative flmid">
          <div class="flgrow">
            <div class="date">
              <input bsDaterangepicker name="StampInDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
              [(ngModel)]="stampInDate" (ngModelChange)="onDateRangeChanged($event)"/>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-8">
        <div class="relative flmid modalinner">
          <div class="flgrow">
            <div class="form-check pl-0">
              <input
                type="checkbox"
                [(ngModel)]="isStrictBoundries"
                id="isIncludeAll"
              />
              <label class="ml-2" for="isIncludeAll" translate
                >lblStrictBoundries</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
        <div class="d-flex">
          <button
            type="button"
            (click)="onSearchReport()"
            class="btn btn-primary btn"
          >
            <em class="fa fa-search"></em>
          </button>
          <button
            type="button"
            (click)="clearSearch()"
            class="ml-2 btn btn-primary btn"
          >
            <em class="far fa-times-circle font16 align-top"></em>
          </button>
        </div>
      </div>
      <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto">
        <!-- Excel -->
        <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
          aria-label="Center Align" style="margin-right: 10px; ">
          <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
        </button>
        <!-- PDF -->
        <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" style="margin-top: -0.4rem;"
          ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
          <em class="far fa-file fa-2x"></em>
          <span class="bdg">PDF</span>
        </button>
      </div>
    </div>
  </div>
  <!-- Search Header -->

  <!-- Data Grid -->
  <div class="container prel">
    <div class="row">
      <div class="c12">
        <div class="card mb-3">
          <!-- Body Header -->
          <div class="card-header d-flex justify-content-between" translate>
            lblTotalSoldHoursReport
            <div class="font16 fontbold">
              <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
              {{ totalCount }}
              &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
            </div>
          </div>

          <!-- Body Content -->
          <div class="table-responsive max-h254">
            <table class="tablest1" id="totalSoldHoursReportPdf">
              <thead>
                <tr>
                  <th class="align-middle" style="width: 55px" scope="col">
                    #
                  </th>
                  <th
                    scope="col"
                    class="align-middle"
                    sortable="mechanicName"
                    (sort)="onSort($event)"
                    translate
                  >
                    lblMechanicName
                  </th>
                  <th scope="col" class="text-center align-middle" translate>
                    lblAppointments <br />
                    <div style="font-size: 12px; color: gray">
                      (
                      <span style="font-size: 12px; color: gray" translate
                        >lblPlanned</span
                      >
                      /
                      <span style="font-size: 12px; color: gray" translate
                        >lblUpsell</span
                      >
                      )
                    </div>
                  </th>
                  <th scope="col" class="text-center align-middle" translate>
                    lblTotalWorkFound
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th>
                  <th scope="col" class="text-center align-middle" translate>
                    lblCustomerApproved
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th>
                  <!-- <th scope="col" class="text-center" translate>
                    lblCustomerRejected
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th> -->
                  <th scope="col" class="text-center align-middle" translate>
                    lblAdminApproved
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th>
                  <!-- <th scope="col" class="text-center" translate>
                    lblAdminRejected
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th> -->
                  <th scope="col" class="text-center align-middle" translate>
                    lblMechanicApproved
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th>
                  <th scope="col" class="text-center align-middle" translate>
                    lblCdssApproved
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th>
                  <!-- <th scope="col" class="text-center" translate>
                    lblCdssRejected
                    <ng-container
                      *ngTemplateOutlet="soldHoursTemplate"
                    ></ng-container>
                  </th> -->
                </tr>
              </thead>

              <tbody>
                <ng-container
                  *ngIf="
                    totalSoldHoursList?.length > 0;
                    else load_NotFound_Template
                  "
                >
                  <tr *ngFor="let item of totalSoldHoursList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td class="text-left">
                      <div>
                        <ngb-highlight
                          [result]="item.mechanicName"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center">
                      <div>
                        <ngb-highlight
                          [result]="item.totalAppointmentCount"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                        /
                        <ngb-highlight
                          [result]="item.appointmentCount"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td
                      class="text-center click"
                      (click)="
                        showDetailedGrid(
                          viewTotalSoldHoursData,
                          item.mechanicId,
                          'workFound'
                        )
                      "
                      onkeydown="void(0)"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          soldHoursDataTemplate;
                          context: {
                            count: item.workFoundCount,
                            hours: item.workFoundHours,
                            amount: item.workFoundCost
                          }
                        "
                      ></ng-container>
                    </td>
                    <td
                      class="text-center click"
                      (click)="
                        showDetailedGrid(
                          viewTotalSoldHoursData,
                          item.mechanicId,
                          'customerApproved'
                        )
                      "
                      onkeydown="void(0)"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          soldHoursDataTemplate;
                          context: {
                            count: item.customerApprovedCount,
                            hours: item.customerApprovedHours,
                            amount: item.customerApprovedCost
                          }
                        "
                      ></ng-container>
                    </td>
                    <td
                      class="text-center click"
                      (click)="
                        showDetailedGrid(
                          viewTotalSoldHoursData,
                          item.mechanicId,
                          'adminApproved'
                        )
                      "
                      onkeydown="void(0)"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          soldHoursDataTemplate;
                          context: {
                            count: item.adminApprovedCount,
                            hours: item.adminApprovedHours,
                            amount: item.adminApprovedCost
                          }
                        "
                      ></ng-container>
                    </td>
                    <td
                      class="text-center click"
                      (click)="
                        showDetailedGrid(
                          viewTotalSoldHoursData,
                          item.mechanicId,
                          'mechanicApproved'
                        )
                      "
                      onkeydown="void(0)"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          soldHoursDataTemplate;
                          context: {
                            count: item.mechanicApprovedCount,
                            hours: item.mechanicApprovedHours,
                            amount: item.mechanicApprovedCost
                          }
                        "
                      ></ng-container>
                    </td>
                    <td
                      class="text-center click"
                      (click)="
                        showDetailedGrid(
                          viewTotalSoldHoursData,
                          item.mechanicId,
                          'cdssApproved'
                        )
                      "
                      onkeydown="void(0)"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          soldHoursDataTemplate;
                          context: {
                            count: item.cdssApprovedCount,
                            hours: item.cdssApprovedHours,
                            amount: item.cdssApprovedCost
                          }
                        "
                      ></ng-container>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="9" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Data Grid -->

  <!-- Data Grid - another version -->
  <div class="container prel" *ngIf="false">
    <div class="row">
      <div class="c12">
        <div class="card mb-3">
          <!-- Body Header -->
          <div class="card-header d-flex justify-content-between" translate>
            lblTotalSoldHoursReport
            <div class="font16 fontbold">
              <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
              {{ totalCount }}
              &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
            </div>
          </div>

          <!-- Body Content -->
          <div
            class="table-responsive max-h254"
            infinite-scroll
            [infiniteScrollDistance]="scrollDistance"
            [infiniteScrollThrottle]="throttle"
            [scrollWindow]="false"
            (scrolled)="onScrollDown()"
          >
            <table class="tablest1 table-bordered" id="totalSoldHoursReportPdf">
              <thead>
                <tr>
                  <th style="width: 55px" scope="col" colspan="4"></th>
                  <th scope="col" class="text-center" colspan="3" translate>
                    lblWorkIdentification
                  </th>
                  <th scope="col" class="text-center" colspan="3" translate>
                    lblAdminApproved
                  </th>
                  <th scope="col" class="text-center" colspan="3" translate>
                    lblCustomerApproved
                  </th>
                </tr>
              </thead>
              <thead>
                <tr>
                  <th style="width: 55px" scope="col">#</th>
                  <th scope="col" class="text-left" translate>lblDealerName</th>
                  <th scope="col" class="text-left" translate>
                    lblMechanicName
                  </th>
                  <th scope="col" class="text-center" translate>
                    lblAppointments
                  </th>
                  <th scope="col" class="text-center" translate>lblCount</th>
                  <th scope="col" class="text-center" translate>lblHours</th>
                  <th scope="col" class="text-center" translate>lblAmount</th>
                  <th scope="col" class="text-center" translate>lblCount</th>
                  <th scope="col" class="text-center" translate>lblHours</th>
                  <th scope="col" class="text-center" translate>lblAmount</th>
                  <th scope="col" class="text-center" translate>lblCount</th>
                  <th scope="col" class="text-center" translate>lblHours</th>
                  <th scope="col" class="text-center" translate>lblAmount</th>
                </tr>
              </thead>

              <tbody>
                <ng-container
                  *ngIf="
                    totalSoldHoursList?.length > 0;
                    else load_NotFound_Template
                  "
                >
                  <tr *ngFor="let item of totalSoldHoursList; let i = index">
                    <td class="click">{{ i + 1 }}</td>
                    <td class="text-left click">
                      <div>
                        <ngb-highlight [result]="item.dealerName">
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-left click">
                      <div>
                        <ngb-highlight
                          [result]="item.mechanicName"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.appointmentCount"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.workFoundCount"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.workFoundHours"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.workFoundCost"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.adminApprovedCount"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.adminApprovedHours"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.adminApprovedCost"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.customerApprovedCount"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.customerApprovedHours"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                    <td class="text-center click">
                      <div>
                        <ngb-highlight
                          [result]="item.customerApprovedCost"
                          tooltipClass="custom-revert"
                        >
                        </ngb-highlight>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Data Grid -->

  <!-- Reusable componenets -->
  <ng-template #soldHoursTemplate>
    <div style="font-size: 12px; color: gray">
      ( <span style="font-size: 12px; color: gray" translate>lblDemand</span> |
      <span style="font-size: 12px; color: gray" translate>lblHour</span> |
      <span style="font-size: 12px; color: gray" translate>lblAmount</span> )
    </div>
  </ng-template>

  <ng-template
    #soldHoursDataTemplate
    let-count="count"
    let-hours="hours"
    let-amount="amount"
  >
    <ngb-highlight [result]="count" tooltipClass="custom-revert">
    </ngb-highlight>
    <span style="color: gray"> | </span>
    {{ hours | number : "1.2-2" }}
    <span style="color: gray"> | </span>
    {{ amount | number : "1.2-2" }}
  </ng-template>
  <!-- Reusable componenets -->

  <ng-template #viewTotalSoldHoursData let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" translate>
        {{ selectedMechanicName }}
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body table-responsive">
      <app-total-sold-hours-details-grid
        [soldHoursDetailsGridData]="soldHoursDetailsGridData"
      ></app-total-sold-hours-details-grid>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary btn-md"
        (click)="modal.close('Cancel click')"
        translate
      >
        <em class="far fa-times-circle font15 align-top mr-2"></em>lblClose
      </button>
    </div>
  </ng-template>
</div>
